const translations = {
    addCustomer: "הוסף לקוח",
    addNewCustomer: "הוספת לקוח חדש",
    fillCustomerDetails: "אנא מלא את פרטי הלקוח החדש. כל השדות הם חובה.",
    customerNumber: "מספר לקוח",
    customerName: "שם לקוח",
    internal: "פנימי",
    external: "חיצוני",
    orderingCustomer: "לקוח מזמין",
    receivingCustomer: "לקוח מקבל",
    cancel: "ביטול",
    add: "הוסף",
    loadingError: "שגיאה בטעינת קוד לקוח",
    serverError: "שגיאה בהוספת לקוח. פנה למנהל המערכת",
    duplicateCustomer: "לקוח עם שם זה כבר קיים",
    saveError: "שגיאה בשמירת לקוח",
    addSuccess: "לקוח נוסף בהצלחה",
  };
  
  export default translations;
  